jQuery.noConflict()(function ($) {
    /**
     * On change for register Inputs
     * */
    $('.reset-input input').on('change',function () {
        var registerInputId = $(this).attr('id');

        if(!registerInputId)
            registerInputId = "standard";

        if($('#'+registerInputId+'-error-missing-value') ){
            $('#'+registerInputId+'-error-missing-value').hide();
        }
        if($('#'+registerInputId+'-error-pattern')){
            $('#'+registerInputId+'-error-pattern').hide();
        }
        if($('#'+registerInputId+'-error-max-value')){
            $('#'+registerInputId+'-error-max-value').hide();
        }
        if($('#'+registerInputId+'-error-min-value')){
            $('#'+registerInputId+'-error-min-value').hide();
        }

    });

    return jQuery;
});